import { CACHE_SETTINGS } from "@/data/constants";

export default function fetcher(
  url,
  options = {},
  // cacheTime = CACHE_SETTINGS.FETCH_CACHE
) {
  // const { next, ...restOptions } = options || {}
  // return fetch(url, {
  //   ...restOptions,
  //   next: { revalidate: cacheTime, ...(next || {}) },
  // })
  return fetch(url, options)
}